import styled from 'styled-components';
import { Space } from 'antd';
import { grayLight04 } from '../../../../styles/colors';

export const ReportingWrapper = styled('div')`
    padding: 0px 100px 60px 100px;
    min-width: 300px;
`;

export const TabsOuterContainer = styled('div')`
    width: 100%;
    border-bottom: 1px solid #c1c1c1;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    box-shadow: inset 0 -3px 0 0 #f2f2f2;
    height: 34px;
    margin-top: 32px;
`;

export const ComingSoonText = styled('p')`
    font-family: 'Proxima Nova';
    font-size: 13px;
    color: #00273b;
    line-height: 16px;
    margin: 0;
    padding-right: 0;
    white-space: nowrap;

    margin-bottom: 4px;

    .bold-text {
        font-family: 'Proxima N W15 Bold';
        font-weight: 400;
        margin: 0;
    }
`;

// export const TabsContainer = styled(Space)`
export const TabsContainer = styled(Space)`
    width: 100%;
    gap: 8px !important;
    height: 34px;
    display: flex;
    align-items: end;
    box-shadow: inset 0 -3px 0 0 #f2f2f2;

    button {
        background: transparent;
        border: 1px solid transparent;
        border-bottom: none;
        padding: 7px 16px;
        font-size: 16px;
        color: #134fbd;
        cursor: pointer;
        border-radius: 6px 6px 0 0;
        font-family: 'Proxima Nova';
        font-weight: 400;
        font-style: normal;
        line-height: 20px; /* 125% */
        &:hover {
            border-radius: 3px 3px 0 0;
            background: ${grayLight04};
        }   
    }

    .active {
        background: #fff;
        border: 1px solid #c1c1c1;
        border-radius: 3px 3px 0 0;
        border-bottom: 0;
        color: #00273b;
        font-family: 'Proxima N W15 Bold';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        position: relative;
        top: 1px;
    }
`;

export const ContentContainer = styled('div')`
    background: #fff;
`;

export const LoadingFallbackContainer = styled(`div`)`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    font-size: 16px;
    color: #666;
`;
export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    padding: 20px;
    text-align: center;
`;

export const ErrorTitle = styled.h3`
    color: #d32f2f;
    margin-bottom: 10px;
`;

export const ErrorMessage = styled.p`
    color: #666;
`;

export const RetryButton = styled.button`
    margin-top: 20px;
    padding: 8px 16px;
    background-color: #1976d2;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #1565c0;
    }
`;

export const ReportTableCmfCell = styled.div<{ width?: number }>`
    display: flex;
    width: ${props => props.width}px;
    gap: 8px;
    height: 20px;
`;